import React from 'react';
import ExpandedText from '../../../../../common/helpers/expanded_text';
import { SvgIcon } from '../../../../../common/sprites';
import { isWebView } from '../../../../../common/config/utils';
import {
  getAltMessage,
  getModeTitle,
  getImage,
  renderPrice
} from './advisor_cta_utils';
import {
  getBGColor,
  getModeShadowColor,
  getModeStatusColor,
  getModeTitleColor,
  modeStatusStrings
} from './style_config';
import classes from './classes.module.scss';

const ctaText = (modeState) => {
  if (isWebView()) {
    return modeStatusStrings[modeState];
  }
  return modeState === 'busy' ? ('advisor_profile.busy') : ('chat.start');
};

export function ForexAdvisorCTA({
  mode,
  modeState,
  liveModes,
  name,
  t,
  localPromoPrices,
  localPrice,
  userAdvisorModeSalePrice,
  currency,
  advisorCTAOnClick,
  freeMinLabel,
  modeUnavailablePoppupVisible,
  renderModeUnavailablePoppup
}) {
  return (
    <button
      onKeyDown={ e => { e.preventDefault(); } }
      type="button"
      onClick={ (event) => advisorCTAOnClick({ e: event }) }
      className={ classes.psiAdvisorCTA }
      style={ { backgroundColor: getBGColor(mode, modeState), ...getModeShadowColor({ modeState }) } }
    >
      <div className={ classes.psiContent }>
        <SvgIcon className={ classes.modeImage } id={ `${ getImage({ mode, modeState, liveModes }) }` } title={ getAltMessage({ mode }) } />
        <div className={ classes.pricesContainer }>
          <div className={ classes.psiTitleContainer }>
            <span className={ classes.modeTitle } style={ { ...getModeTitleColor(modeState, mode) } }>
              <ExpandedText
                customClasses={ { text: classes.modeTitle } }
                ellipsis
              >
                { getModeTitle({ name, mode, t }) }
              </ExpandedText>
            </span>
            { freeMinLabel && <div className={ classes.psiFreeMinContainer }>{ freeMinLabel }</div> }
          </div>
          { renderPrice({
            localPromoPrices, localPrice, userAdvisorModeSalePrice, modeState, mode, currency
          }) }
        </div>
      </div>
      <span
        className={ classes.modeStatus }
        style={ {
          ...getModeStatusColor({
            mode, modeState, liveModes, isFreeMinLabel: true
          })
        } }
      >
        { t(ctaText(modeState)) }
      </span>
      { modeUnavailablePoppupVisible && renderModeUnavailablePoppup() }
    </button>
  );
}
